export const GROUP_EVENT_LOADING = 'GROUP_EVENT::GROUP_EVENT_LOADING';
export const GROUP_EVENT_RECEIVE = 'GROUP_EVENT::GROUP_EVENT_RECEIVE';
export const GROUP_EVENT_ERROR = 'GROUP_EVENT::GROUP_EVENT_ERROR';

export const GROUP_EVENT_TABLEPROPS = 'GROUP_EVENT::GROUP_EVENT_TABLEPROPS';

export const SAVE_FILTERS = 'GROUP_EVENT::SAVE_FILTERS';

export const RESET_STATE = 'GROUP_EVENT::RESET_STATE';